import { ProjectSummaryResponse, ProjectCountHistoryEntity } from 'src/types'

export const ProjectSummaryTranslator = {
  toEntities: (response: ProjectSummaryResponse): ProjectCountHistoryEntity[] => {
    return (
      response.projectCountHistories?.map(history => {
        const yearString = history.month.slice(0, 4)
        const monthString = history.month.slice(4)

        return {
          year: Number.parseInt(yearString),
          month: Number.parseInt(monthString),
          activatedCount: history.activatedCount,
        }
      }) ?? []
    )
  },
} as const
